import React,{useContext, useEffect} from 'react';
import LeftSitebarMenu from '../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from '../../components/rightSitebarMenu/RightSitebarMenu';
import MainMenu from './../../components/mainMenu/MainMenu';
import newDiscussionIcon from '../../assets/img/forum-imgs/new-discussion-icon.svg'
import FilterAndShort from './../../components/filterAndShort/FilterAndShort';
import ForumDatas from './forumDatas/ForumDatas';
import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../App';
const Forum = () => {
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'forum';
        setPageName.forum.left = false;
        setPageName.forum.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.forum.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.forum.right = status
            setShowHideSidebar(newStatus)
        }
    }
    return (
        <>
            {/* Main Menu / Main Navbar */}
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-lg">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.forum?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                         <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* Center Menu */}
                    <div className="col-lg-6">
                        {/* Add A Forum and Filte section here */}
                        <div className="row my-2">
                            {/* Filter and Short Seciton Component */}
                            <div className="row mb-2 gap-2 gap-lg-0">
                                <div className="col-12 col-lg-8 col-md-6">
                                    <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"> <img src={newDiscussionIcon} alt="" className='me-3' />Start New Discussion</button>
                                </div>
                                <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-start gap-4">
                                    <FilterAndShort></FilterAndShort>
                                </div>
                            </div>
                        </div>
                        {/* Forum Details Here */}
                        <ForumDatas></ForumDatas>
                        
                     </div>
                    {/* Right Site Bar Menu */}
                    <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.forum?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>  
                </div>
            </div>
        </>
    );
};

export default Forum;